// src/pages/Attendance/LeaveTab.tsx

import React from "react";
import LeaveBalance from "./LeaveBalancePage";
import LeavePage, { LeaveSection } from "./LeavePage";
import LeaveStatusList from "./LeaveStatusList";
import  { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootDispatch, RootState } from "../../store";
import {
  fetchLeaveBalance ,
} from "../../store/slices/leaveSlice";

type ExtendedLeaveSection = LeaveSection | "balance";

interface LeaveTabProps {
  activeSection: ExtendedLeaveSection;
  onSectionChange: (section: ExtendedLeaveSection) => void;
}

const tabLabels: Record<ExtendedLeaveSection, string> = {
  balance: "Balance",
  apply: "Apply Leave",
  grant: "Comp-Off Grant",
  pending: "Pending",
  history: "History",
};

const LeaveTab: React.FC<LeaveTabProps> = ({ activeSection, onSectionChange }) => {
const dispatch = useDispatch<RootDispatch>();

useEffect(() => {
if (activeSection === "balance" || activeSection === "apply") {
    dispatch(fetchLeaveBalance());
  }
}, [activeSection, dispatch]);

  return (
    <div className="max-w-4xl mx-auto px-4">
      {/* Sub-tab buttons */}
      <div className="border-b border-gray-200 flex">
        {(Object.keys(tabLabels) as ExtendedLeaveSection[]).map((section) => (
          <button
            key={section}
            onClick={() => onSectionChange(section)}
            className={`flex-1 py-3 text-center text-sm font-medium transition-all duration-200 ${
              activeSection === section
                ? "text-blue-600 border-b-2 border-blue-500 font-semibold"
                : "text-gray-500 hover:text-blue-500"
            }`}
          >
            {tabLabels[section]}
          </button>
        ))}
      </div>

      {/* Sub-tab content */}
      <div className="mt-2 bg-white rounded-xl shadow-sm border border-gray-100 p-2">
        {activeSection === "balance" && (
          <LeaveBalance onLeaveTypeClick={() => onSectionChange("apply")} />
        )}

        {(activeSection === "apply" || activeSection === "grant") && (
          <LeavePage section={activeSection as LeaveSection} />
        )}

        {(activeSection === "pending" || activeSection === "history") && (
          <LeaveStatusList type={activeSection} context="leave" />
        )}
      </div>
    </div>
  );
};

export default LeaveTab;
